const errorMessages: Record<string, string> = {
  unauthorized: "Please sign in again to continue.",
  account_inactive: "This account is inactive. Contact support for help.",
  key_fetch_failed: "We could not load your API keys.",
  key_create_failed: "We could not create a new API key.",
  key_limit_reached:
    "Anonymous trial accounts can create one API key. Upgrade to a full account to unlock 50 free calls, then keep an active saved card for 100 total free calls.",
  key_revoke_failed: "We could not revoke that API key.",
  invalid_key_id: "That API key could not be found.",
  mcp_key_fetch_failed: "We could not load your MCP keys.",
  mcp_key_create_failed: "We could not create a new MCP key.",
  mcp_key_revoke_failed: "We could not revoke that MCP key.",
  mcp_key_not_found: "That MCP key could not be found.",
  invalid_mcp_key_id: "That MCP key could not be found.",
  mcp_audit_fetch_failed: "We could not load MCP activity yet.",
  usage_fetch_failed: "We could not load usage data.",
  billing_fetch_failed: "We could not load billing data.",
  billing_emails_invalid: "Enter between 1 and 10 valid email addresses.",
  billing_emails_update_failed: "Could not save billing emails. Please try again.",
  billing_config_missing: "Billing is not configured yet. Contact support.",
  prepaid_billing_not_available:
    "This account uses monthly invoicing. Prepaid billing controls are unavailable.",
  billing_unavailable:
    "We could not confirm your billing mode. No billing changes were made.",
  monthly_spend_cap_invalid:
    "Enter a valid monthly USD spend cap between $0.00 and $10,000,000.00.",
  monthly_spend_cap_update_failed:
    "We could not save the monthly spend cap. Try again.",
  monthly_spend_cap_below_current_exposure:
    "The cap cannot be lower than this month's billed usage and in-flight reservations.",
  monthly_postpaid_contract_not_found:
    "An active monthly invoice contract is required to change these settings.",
  payment_invalid_package: "That credit package is not available.",
  payment_invalid_amount: "Enter a valid custom amount of at least R10.00.",
  payment_create_failed: "We could not start that payment. Try again.",
  auto_topup_config_invalid:
    "Enter a valid top-up amount, trigger balance, and monthly cap.",
  auto_topup_token_required:
    "Set up PayFast tokenization before enabling automatic top-ups.",
  auto_topup_setup_failed:
    "We could not start the PayFast auto top-up setup flow.",
  auto_topup_update_failed:
    "We could not save the auto top-up settings.",
  payment_method_required:
    "Select a saved payment method before enabling automatic top-ups.",
  payment_method_not_found:
    "That saved payment method could not be found.",
  payment_method_setup_failed:
    "We could not start the PayFast payment method setup flow.",
  payment_method_update_failed:
    "We could not update that saved payment method.",
  payment_method_delete_failed:
    "We could not remove that saved payment method.",
  invoice_unavailable: "That invoice is not available yet.",
  invoice_generate_failed: "We could not generate that invoice.",
  payment_not_found: "That payment could not be found.",
  missing_api_key: "API key is required.",
  invalid_api_key: "API key is invalid.",
  public_test_unavailable:
    "The public tester is not available right now. Please try again later.",
  captcha_required: "Complete human verification before running the test.",
  captcha_invalid: "Human verification expired or could not be confirmed. Please try again.",
  captcha_unavailable:
    "Human verification is temporarily unavailable. Please try again later.",
  test_config_missing:
    "Tester setup is incomplete in this environment. Add the required server env vars.",
  test_quota_backend_unavailable:
    "Tester quota backend is not configured. Apply the tester quota migration to the connected Supabase project.",
  public_test_limit_reached:
    "Test limit reached for this preview. Sign up for your own API key or contact support.",
  public_test_ip_limit_reached:
    "Daily tester limit reached from this network. Sign up for your own API key or contact support.",
  test_gateway_unavailable:
    "The tester is temporarily unavailable. Please retry in a minute.",
  unsupported_endpoint: "That endpoint is not available in this tester.",
  missing_image_input: "Add the required image file(s) before running the test.",
  invalid_target_vector:
    "Target vector JSON is invalid. Provide an array of numeric values.",
  insufficient_credits: "Insufficient credits to run that request.",
  rate_limited: "Rate limit exceeded. Slow down and retry.",
  queue_full: "The queue is full. Try again soon.",
  queue_timeout: "The queue wait time was exceeded. Try again soon.",
  request_too_large: "The request exceeded the max size limit.",
  image_too_large: "The image exceeded the max image size limit.",
  no_face_detected:
    "We could not detect a usable face in one of the images. Make sure the full face is visible, then try a clearer crop, better lighting, or a different detector.",
  missing_model_name: "Model name is required for this endpoint.",
  model_not_allowed: "The requested model is not allowed.",
  model_mismatch: "Embeddings were created with a different model.",
  unsupported_file_type: "Unsupported file type. Use a JPG or PNG image.",
  upstream_timeout: "The request timed out. Try a smaller image or retry.",
  upstream_failed: "The model server failed. Retry the request.",
  unauthorized_internal: "Internal service authorization failed.",
};

export function getApiErrorMessage(code: string | null | undefined) {
  if (!code) return null;
  return errorMessages[code] ?? "Something went wrong. Please try again.";
}
